import { Injectable } from '@angular/core';
import { THEME_CONSTANTS } from '../../../../theme/theme.constant';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  /**
   * set css variables based on logged in status
   */
  setThemeVariables() {
    this.setValues(THEME_CONSTANTS.GLD);
  }

  /**
   * set css variables
   * @param themeConstants constants
   */
  setValues(themeConstants: { key: string; value: string | null }[]) {
    themeConstants.forEach((element: { key: string; value: string | null }) => {
      document.documentElement.style.setProperty(element.key, element.value);
    });
  }
}
